import { render, staticRenderFns } from "./ui-segmented.vue?vue&type=template&id=43a768a7&"
import script from "./ui-segmented.vue?vue&type=script&lang=js&"
export * from "./ui-segmented.vue?vue&type=script&lang=js&"
import style0 from "./ui-segmented.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a768a7')) {
      api.createRecord('43a768a7', component.options)
    } else {
      api.reload('43a768a7', component.options)
    }
    module.hot.accept("./ui-segmented.vue?vue&type=template&id=43a768a7&", function () {
      api.rerender('43a768a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-segmented/ui-segmented.vue"
export default component.exports